(() => {
  if(document.querySelector('.sticky-atc')){
    /*
    const atcObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {      
          console.log(entry)
          if(entry.isIntersecting){
            document.getElementsByClassName('sticky-atc')[0].classList.remove('active');
          } else {
            document.getElementsByClassName('sticky-atc')[0].classList.add('active');
          }
        });
      },
      {
        threshold: 0.25
      }
    );

    atcObserver.observe(document.querySelector('.ProductForm__AddToCart'));
    */
    let productFormWrap = document.getElementsByClassName('ProductForm')[0]
    let multipleSizes = false; 

    // uncomment and update below for multiple variants
    //if(productFormWrap.getElementsByClassName('product-option--Size').length > 0){
      //if(productFormWrap.getElementsByClassName('product-option--Size')[0].getElementsByClassName('option').length > 1){
        //multipleSizes = true;
      //}
    //}

    let stickyAtcBtn = document.getElementById('sticky-atc-btn');
    let stickySelectSizeBtn = document.getElementById('sticky-select-size-btn');
    let atc = productFormWrap.getElementsByClassName('ProductForm__AddToCart')[0];

    if(multipleSizes){
      stickyAtcBtn.style.display = "none";
      stickySelectSizeBtn.style.display = "block";

      // uncomment and update below for multiple variants
      //Array.from(productFormWrap.getElementsByClassName('ProductForm__Variants')[0].getElementsByClassName('product__swatch')).forEach( el => {
        //el.addEventListener('click', () => {
          //stickyAtcBtn.style.display = "block";
          //stickySelectSizeBtn.style.display = "none";
        //})
      //})

    } else {
      // product only has 1 size
      stickyAtcBtn.style.display = "block";
      stickySelectSizeBtn.style.display = "none";
    }

    stickyAtcBtn.innerText = atc.innerText; 
    stickyAtcBtn.addEventListener('click', () => {
      atc.click();
    })
    stickySelectSizeBtn.addEventListener('click', () => {
      window.scroll(0, document.getElementsByClassName('ProductForm')[0].offsetTop - (window.innerHeight - 164));
    })
  }  
})();